import { render, staticRenderFns } from "./TheMaskIcon.vue?vue&type=template&id=583307b4&scoped=true&"
import script from "./TheMaskIcon.vue?vue&type=script&lang=js&"
export * from "./TheMaskIcon.vue?vue&type=script&lang=js&"
import style0 from "./TheMaskIcon.vue?vue&type=style&index=0&id=583307b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583307b4",
  null
  
)

export default component.exports